import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import BackToTop from './BackToTop'
import StickyNav from './StickyNav'
import CityPicker from './CityPicker'
import UnsubscribeForm from './UnsubscribeForm'

import axios from 'axios'
import Cookies from 'js-cookie'
import _ from 'lodash'
import Vuelidate from 'vuelidate'
import MQ from 'vue-match-media/dist'
import 'core-js/es6/set'
import 'core-js/fn/array/from'
import 'core-js/es6/promise'

if (window.sentry_dsn) {
  Raven.config(window.sentry_dsn, {
    release: window.sentry_release
  }).addPlugin(RavenVue, Vue).install()
} else {
  console.error("window.sentry_dsn not defined - Sentry not enabled")
}

Vue.use(Vuelidate)
Vue.use(MQ)

Vue.component(BackToTop.name, BackToTop)
Vue.component(StickyNav.name, StickyNav)
Vue.component(CityPicker.name, CityPicker)
Vue.component(UnsubscribeForm.name, UnsubscribeForm)

if (!window.django) {
  console.error("window.django not defined - ensure Django's jsi18n is loaded before this script")
}

if (!Element.prototype.matches) {
    Element.prototype.matches = 
        Element.prototype.matchesSelector || 
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector || 
        Element.prototype.oMatchesSelector || 
        Element.prototype.webkitMatchesSelector ||
        function(s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;
            while (--i >= 0 && matches.item(i) !== this) {}
            return i > -1;            
        };
}

Vue.prototype.gettext = window.django.gettext
Vue.prototype.pgettext = window.django.pgettext
Vue.prototype.lang = window.django.LANGUAGE_CODE

const vueApps = document.getElementsByClassName('vue-app')

for (let i = 0; i < vueApps.length; i++) {
  const element = vueApps[i]
  const newVue = new Vue({
    el: element,
    data: {
      document: document,
      window: window
    }})
}

import { required, email } from 'vuelidate/lib/validators'

// Hand-create this Vue object, since we need custom handling for data and submit handling
const vueSignup = new Vue({
  el: '#vue-signup',

  data() {
    return {
      email: '',
      rawErrors: {},
      messages: {}
    }
  },

  computed: {
    errors() {
      // return _.flatten(_.values(this.rawErrors))
      return this.rawErrors
    }
  },

  methods: {
    handleSubmit(ev) {
      this.$v.$touch()
      this.$refs.cityPicker.$v.$touch()

      if ( this.$v.$invalid ) return

      this.rawErrors = {}
      this.messages = {}

      let formAction = ev.target.action
      let formData = {
        city: this.$refs.cityPicker.city,
        province: this.$refs.cityPicker.province,
        email: this.email
      }

      let formHeaders = { 'X-CSRFToken': Cookies.get('csrftoken') }

      axios.post(formAction, formData, { headers: formHeaders }).then(
        (success) => this.messages = success.data.success,
        (error) => this.rawErrors = error.response.data.errors
      )
    }
  },

  validations: {
    email: {
      required,
      email
    }
  }
})

window.Vue = Vue



// WEBPACK FOOTER //
// ./js/index.js